export const ENTER_SILENT_LOGIN_START_PATH = '/enter_home_auth/silent-login/start';
export const ENTER_SILENT_LOGIN_PATH = '/auth/silent-login';

function buildPath(pathname: string, params: Record<string, string>): string {
  const searchParams = new URLSearchParams(params);
  return `${pathname}?${searchParams.toString()}`;
}

export function resolveEnterSilentLoginReturnTo(
  candidate: string | null | undefined,
  origin: string
): string {
  if (!candidate) {
    return '/';
  }

  try {
    const target = new URL(candidate, origin);
    const isAuthPath = target.pathname === '/auth' || target.pathname.startsWith('/auth/');

    if (target.origin !== origin || isAuthPath) {
      return '/';
    }

    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return '/';
  }
}

export function buildEnterSilentLoginStartPath(returnTo: string, authTraceId?: string): string {
  return buildPath(ENTER_SILENT_LOGIN_START_PATH, {
    returnTo,
    ...(authTraceId ? { auth_trace_id: authTraceId } : {}),
  });
}

export function buildEnterSilentLoginPath(
  returnTo: string,
  riskSessionId: string
): string {
  return buildPath(ENTER_SILENT_LOGIN_PATH, {
    returnTo,
    risk_session_id: riskSessionId,
  });
}
